export const CALCULATOR_NIGHTS: number[] = [7, 10, 14, 17, 21]
export const CALCULATOR_COST_PER_NIGHT: number[] = [95, 150, 175, 200, 250]
export const CALCULATOR_YEARS: number[] = [10, 15, 20, 30]
export const CALCULATOR_INFLATION: number[] = [4, 6, 8]